import React, { useEffect } from 'react';
import { CLOSE_ICON, LOCATIONCLOSEMODAL, MENU, MODAL_CTA_CLICK_ACTION, MODAL_PAGEVIEW, ORDERINGOFFLINEMODAL } from '../../../constants/AnalyticsConstants';
import useStore from '../../../store/useStore';
import Button from '../../Atoms/Button/Button';
import Link from '../../Atoms/Link/Link';
import Modal from '../Modal/Modal';
import './OrderAheadPopup.scss'
import classNames from 'classnames';
import { multipleAndCheck, ternaryCheck } from '../../../Utils/WindowUtils';
import _isEmpty from 'lodash/isEmpty';
import { ButtonList, OrderAheadPopupInterface } from '../../Interfaces/OrderAheadPopupInterface';

const OrderAheadPopup: React.FC<OrderAheadPopupInterface> = ({
  showModal,
  modalData,
  closePopup,
  name,
}) => {
  const { setAnalyticsProducts, setAttemptTracker } = useStore();
  const virtualName = modalData?.title?.toLowerCase().includes("cept") ? ORDERINGOFFLINEMODAL : LOCATIONCLOSEMODAL
  useEffect(() => {
    if(!_isEmpty(modalData)) {
    setAnalyticsProducts({
      warningMessage: modalData?.message?.toLowerCase(),
      warningMessageUI: 1,
      virtualName,
    });
    setAttemptTracker([{ name: MODAL_PAGEVIEW }]);
  }
  }, [modalData]);
  const onClick = (e: React.SyntheticEvent, analyticsText: string) => {
    if (name === MENU) {
      closePopup();
    }
    handleAnalytics(analyticsText);
    e.stopPropagation();
  };

  const handleAnalytics = (analyticsText: string) => {
    setAnalyticsProducts({
      clickActionName: analyticsText?.toLowerCase(),
      virtualName
    });
    setAttemptTracker([{ name: MODAL_CTA_CLICK_ACTION }]);
  };

  return (
    <Modal
      isShown={showModal}
      title={modalData.title}
      description={modalData.message}
      onButtonClick={() => {
        handleAnalytics(CLOSE_ICON);
        setTimeout(() => {
          closePopup()
        }, 500);
      }}
      isClosebtn={true}
      modalParentClass="order-ahead-popup"
    >
      {
        modalData?.buttonList?.map((cta: ButtonList, index: number) => {
          const buttonListLength = modalData?.buttonList?.length ?? 1;
          const isLastCta = index === buttonListLength - 1;
          const ctaClassName = classNames('', {
            'popup__button': index === 0,
            'popup__button white-bg': index > 0 && !isLastCta,
            'popup__link': multipleAndCheck(isLastCta, index !== 0),
          });
          return (<>
            {
              ternaryCheck(!_isEmpty(cta.url),
                <Link
                  text={cta.buttonText}
                  href={cta.url}
                  onClick={e => onClick(e, cta.analyticsText)}
                  className={ctaClassName}
                  testAutoId={`store-close-cta-${index}`}
                />
                ,
                <Button
                  className={ctaClassName}
                  testAutoId={`store-close-cta-${index}`}
                  onClick={() => { 
                    closePopup();
                    handleAnalytics(cta.analyticsText);
                    }}>
                  {cta.buttonText}
                </Button>
              )
            }
          </>)
        })
      }
    </Modal>
  );
};

export default OrderAheadPopup;
